import { Form, InputNumber, Select, DatePicker, Radio } from 'antd';
import moment from 'moment';
const { Option } = Select;

export const renderFormItem = (field, handleChange) => {

    const commonProps = {
        name: field.name,
        label: field.label,
        rules: field.required ? [{ required: true, message: `${field.label} est requis` }] : [],
    };

    if (field.visible === false) return null;

    console.log("field", field);

    switch (field.input_type_code) {
        case 'SelectList':
            return (
                <Form.Item key={field.name} {...commonProps} initialValue={field.values?.[0]}>
                    <Select
                        placeholder={field.placeholder}
                        disabled={field.read_only}
                        onChange={(value) => {
                            const selectedItem = field.items.find(item => item.value === value);
                            const referencial_code = selectedItem?.referencial_code || field.name;
                            handleChange(referencial_code, value);
                        }}
                    >
                        {field.items.map((item) => (
                            <Option key={item.value} value={item.value}>
                                {item.text}
                            </Option>
                        ))}
                    </Select>
                </Form.Item>
            );

        case 'RadioList':
            return (
                <Form.Item key={field.name} {...commonProps} initialValue={field.values?.[0]}>
                    <Radio.Group
                        disabled={field.read_only}
                        onChange={(e) => {
                            const value = e.target.value;
                            const selectedItem = field.items.find(item => item.value === value);
                            const referencial_code = selectedItem?.referencial_code || field.name;
                            handleChange(referencial_code, value);
                        }}
                    >
                        {field.items.map((item) => (
                            <Radio key={item.value} value={item.value}>
                                {item.text}
                            </Radio>
                        ))}
                    </Radio.Group>
                </Form.Item>
            );

        case 'Money':
            return (
                <Form.Item key={field.name} {...commonProps} initialValue={field.values?.[0]}>
                    <InputNumber
                        placeholder={field.placeholder}
                        min={Number(field.min)}
                        max={Number(field.max)}
                        style={{ width: '100%' }}
                        disabled={field.read_only}
                        onChange={(value) => handleChange(field.name, value)}
                        formatter={value =>
                            new Intl.NumberFormat('fr-FR', {
                                style: 'currency',
                                currency: field.tags?.[0]?.split('=')[1] || 'XOF',
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0,
                            }).format(value)
                        }
                        parser={value => value.replace(/\s?[^0-9]/g, '')}
                    />
                </Form.Item>
            );

        case 'Integer':
            return (
                <Form.Item key={field.name} {...commonProps} initialValue={parseInt(field.values?.[0], 10)}>
                    <InputNumber
                        placeholder={field.placeholder}
                        min={Number(field.min)}
                        max={Number(field.max)}
                        style={{ width: '100%' }}
                        disabled={field.read_only}
                        onChange={(value) => handleChange(field.name, value)}
                    />
                </Form.Item>
            );

        case 'Date':
            return (
                <Form.Item
                    key={field.name}
                    {...commonProps}
                    initialValue={field.values?.[0] ? moment(field.values[0]) : null}
                >
                    <DatePicker
                        placeholder={field.placeholder}
                        style={{ width: '100%' }}
                        disabled={field.read_only}
                        disabledDate={(current) => current && current > moment(field.max)}
                        onChange={(date, dateString) => handleChange(field.name, dateString)}
                    />
                </Form.Item>
            );

        default:
            return null;
    }
};
